import { BaseError } from "./AuthError";

export class GenericError extends BaseError {
  constructor(
    message: string = "Ocorreu um problema. Por favor, tente novamente",
    code: string = "GENERIC_ERROR",
  ) {
    super(message, code);
  }
}

export * from "./AuthError";
export * from "./DomainError";
export * from "./InfraError";
